import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/common/components/ui/button';
import { cn } from '@/lib/utils';

interface Props {
  href: string;
  className?: string;
}

export const ExternalLinkButton = ({ href, className }: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn(
        'size-auto p-2 hover:bg-white/10 transition-opacity',
        className,
      )}
      asChild
      aria-label={t('externalLink')}
    >
      <a href={href} target="_blank" rel="noopener noreferrer">
        <ExternalLink size={20} color="#FDF8F7" />
      </a>
    </Button>
  );
};
